import React, { useState } from 'react';
import { Theme, ThemePanel, AlertDialog, Button, Flex } from '@radix-ui/themes';
import { MultipleContainers } from './widgets/MultipleContainers/MultipleContainers.tsx';

import './App.css';
import { restrictToFirstScrollableAncestor } from '@dnd-kit/modifiers';

/**
 * Use dynamic import for DebuggerBar
 * This method ensures that the DebuggerBar component and its related code are completely excluded from the production build,
 * thereby reducing the bundle size and improving performance for users who are not in development mode.
 * example: () => import('./widgets/DebuggerBar/DebuggerBar')
 */
const lazyDevOnly = (
  importPromise: () => Promise<{ default: React.ComponentType }>
) => {
  const LazyComponent = process.env.IS_DEV ? React.lazy(importPromise) : null;

  return LazyComponent ? (
    <React.Suspense fallback={<div>Loading...</div>}>
      <LazyComponent />
    </React.Suspense>
  ) : null;
};

function MyApp() {
  return (
    <div className="App">
      <header className="OfflineHeader">
        <AlertDialog.Root>
          <AlertDialog.Trigger>
            <button
              className="OfflineHeaderButton"
              type="button"
              aria-label="Show offline mode privacy notice"
            >
              OFFLINE
            </button>
          </AlertDialog.Trigger>
          <AlertDialog.Content maxWidth="400px">
            <AlertDialog.Title>Your Private Space</AlertDialog.Title>
            <AlertDialog.Description size="2">
              Your data stays where it belongs with you. This app saves all your
              tasks and notes directly to your local device. There are no
              tracking scripts, no remote databases, and absolutely none of your
              personal data will ever leave your browser.
            </AlertDialog.Description>
            <Flex gap="3" mt="4" justify="end">
              <AlertDialog.Action>
                <Button variant="solid" color="gray">
                  Got it
                </Button>
              </AlertDialog.Action>
            </Flex>
          </AlertDialog.Content>
        </AlertDialog.Root>
      </header>
      <MultipleContainers
        handle
        // minimal={true}
        vertical={true}
        trashable={false}
        scrollable={true}
      // modifiers={[restrictToFirstScrollableAncestor]}
      />
    </div>
  );
}
function App() {
  return (
    <>
      <Theme accentColor="gray" grayColor="sand" radius="small">
        <MyApp />
        {/* {process.env.IS_DEV && <ThemePanel />} */}
      </Theme>

      {lazyDevOnly(() => import('./widgets/DebuggerBar/DebuggerBar'))}
    </>
  );
}

export default App;
